//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable*/
import { readCookie, createCookie } from "@/assets/js/appFunc";
import ViewAQDropdown from "./Views/ViewAQDropdown.vue";
import ViewAQAvatar from "./Views/ViewAQAvatar.vue";
import ViewAQMenu from "./Views/ViewAQMenu.vue";
import ViewAQInput from "./Views/ViewAQInput.vue";
import ViewAQDatetime from "./Views/ViewAQDatetime.vue";
import ViewAQBadge from "./Views/ViewAQBadge.vue";
import ViewAQTooltip from "./Views/ViewAQTooltip.vue";
import ViewAQButton from "./Views/ViewAQButton.vue";
import ViewAQChip from "./Views/ViewAQChip.vue";
import ViewAQDropdownBadge from "./Views/ViewAQDropdownBadge.vue";
import ViewAQToggle from "./Views/ViewAQToggle.vue";
import ViewAQRadio from "./Views/ViewAQRadio.vue";
import ViewAQCheckbox from "./Views/ViewAQCheckbox.vue";
import ViewAQDialog from "./Views/ViewAQDialog.vue";
import ViewAQModal from "./Views/ViewAQModal.vue";
import ViewAQToast from "./Views/ViewAQToast.vue";
import ViewTestColors from "./Views/ViewTestColors.vue";
import ViewAQCard from "./Views/ViewAQCard.vue";
import ViewAQUploader from "./Views/ViewAQUploader.vue";
import ViewAQDataTable from "./Views/ViewAQDataTable.vue";
import ViewAQLeftSideBar from "./Views/ViewAQLeftSideBar.vue";
import ViewVuelidateExample from "./Views/ViewVuelidateExample.vue";
import ViewAQDefaultState from "./Views/ViewAQDefaultState.vue";
import ViewAQMonacoEditor from "./Views/ViewAQMonacoEditor.vue";
import ViewAQDeniedPage from "./Views/ViewAQDeniedPage.vue";
import ViewAQContainer from "./Views/ViewAQContainer.vue";
import ViewAQList from "./Views/ViewAQList.vue";
import ViewAQSearch from "./Views/ViewAQSearch.vue";
import ViewAQEmptySearch from "./Views/ViewAQEmptySearch.vue"
import ViewAQHeaderSubheader from "./Views/ViewAQHeaderSubheader.vue";
import ViewAQTabs from "./Views/ViewAQTabs.vue";
import ViewAQEmptyState from "./Views/ViewAQEmptyState.vue";
import ViewAQAvatarUploader from "./Views/ViewAQAvatarUploader.vue";
import ViewAQSkeleton from "./Views/ViewAQSkeleton.vue";
import ViewAQTimeline from "./Views/ViewAQTimeline.vue";
import ViewAQHistory from "./Views/ViewAQHistory.vue";
import ViewAQTreeConfigBody from "./Views/ViewAQTreeConfigBody.vue";
import ViewDataSelector from "./Views/ViewDataSelector.vue";

export default {
    name: "Components",
    components: {
        ViewAQCard,
        ViewAQDropdown,
        ViewAQMenu,
        ViewAQAvatar,
        ViewAQContainer,
        ViewAQHeaderSubheader,
        ViewAQTabs,
        ViewAQInput,
        ViewAQDatetime,
        ViewAQBadge,
        ViewAQButton,
        ViewAQChip,
        ViewAQDropdownBadge,
        ViewAQTooltip,
        ViewAQToggle,
        ViewAQRadio,
        ViewAQCheckbox,
        ViewAQDialog,
        ViewAQModal,
        ViewTestColors,
        ViewAQToast,
        ViewAQUploader,
        ViewAQDataTable,
        ViewAQLeftSideBar,
        ViewVuelidateExample,
        ViewAQDefaultState,
        ViewAQMonacoEditor,
        ViewAQDeniedPage,
        ViewAQList,
        ViewAQEmptyState,
        ViewAQSearch,
        ViewAQEmptySearch,
        ViewAQAvatarUploader,
        ViewAQSkeleton,
        ViewAQTimeline,
        ViewAQHistory,
        ViewAQTreeConfigBody,
        ViewDataSelector
    },
    data() {
        return {
            componentsList: [
                "ViewAQCard",
                "ViewTestColors",
                "ViewAQAvatar",
                "ViewAQContainer",
                "ViewAQHeaderSubheader",
                "ViewAQTabs",
                "ViewAQBadge",
                "ViewAQButton",
                "ViewAQInput",
                "ViewAQDatetime",
                "ViewAQChip",
                "ViewAQDropdownBadge",
                "ViewAQMenu",
                "ViewAQDropdown",
                "ViewAQModal",
                "ViewAQTooltip",
                "ViewAQCheckbox",
                "ViewAQRadio",
                "ViewAQToggle",
                "ViewAQDialog",
                "ViewAQToast",
                "ViewAQUploader",
                "ViewAQDataTable",
                "ViewAQLeftSideBar",
                "ViewVuelidateExample",
                "ViewAQDefaultState",
                "ViewAQMonacoEditor",
                "ViewAQDeniedPage",
                "ViewAQList",
                "ViewAQEmptyState",
                "ViewAQSearch",
                "ViewAQEmptySearch",
                "ViewAQAvatarUploader",
                "ViewAQSkeleton",
                "ViewAQTimeline",
                "ViewAQHistory", 
                "ViewAQTreeConfigBody",
                "ViewDataSelector"
            ],
            is: "ViewAQSkeleton",
            refActiveName: "activeComp",
            activeCookieName: "viewComponent"
        };
    },
    beforeMount() {
        const selectedCookie = readCookie(this.activeCookieName);
        this.is = selectedCookie || this.is;
    },
    mounted() {
        this.componentsList.sort();
        this.$nextTick(() => {
            if (this.$refs[this.refActiveName]) {
                this.$refs[this.refActiveName][0].scrollIntoView();
            }
        });        
    },
    methods: {
        isActive(component) {                        
            return { active: this.is === component };
        },
        onEntryClick(component) {
            this.is = component;
            createCookie(this.activeCookieName, component, 777);
        }
    }
};
